import React from 'react';
import classNames from 'classnames';
import MuiIconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

interface IIconButtonProps {
  children: React.ReactNode;
  tooltipMessage?: string;
}

type IProps = IIconButtonProps & IconButtonProps;

export const IconButton: React.FunctionComponent<IProps> = ({
  children,
  className,
  disabled,
  tooltipMessage,
  ...restProps
}: IProps) => {
  const iconButton = (
    <MuiIconButton
      disabled={disabled}
      className={classNames(className)}
      {...restProps}
    >
      {children}
    </MuiIconButton>
  );

  if (tooltipMessage) {
    return <Tooltip title={tooltipMessage}>{iconButton}</Tooltip>;
  }
  return iconButton;
};
